var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-view-container"},[_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.image}})]),_c('div',{staticClass:"form-container"},[_vm._m(0),_vm._t("form"),_vm._t("options")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container"},[_c('img',{attrs:{"src":require("@/assets/images/logo-red.png")}})])
}]

export { render, staticRenderFns }